export default {
  aboutUs: {},
  selectedAboutUs: {},
};
